module.exports = __webpack_public_path__ + "static/img/5.534de4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/5.png
// module id = LyX9
// module chunks = 0